/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-26 17:25:47
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-09-08 17:08:24
 */
import store from '@/store';
import { isNumber } from 'lodash';
import Vue from 'vue';

function authPermission(permission) {
	const all_permission = '*:*:*';
	const permissions = store.getters && store.getters.accountPermissions;
	if (permission && permission.length > 0) {
		return permissions.some(v => {
			return all_permission === v || v === permission;
		});
	} else {
		return false;
	}
}

function authRole(role) {
	const super_admin = 1;
	const roles = store.getters && store.getters.accountRoles;
	if (isNumber(role) || role?.length > 0) {
		return roles.some(v => {
			return super_admin === v || v === role;
		});
	} else {
		return false;
	}
}

export const checkAuth = (cb, auth) => {
	if (!Vue.prototype.$auth.hasPermi(auth)) {
		return;
	}
	return cb;
};
export default {
	// 验证用户是否具备某权限
	hasPermi(permission) {
		return authPermission(permission);
	},
	// 验证用户是否含有指定权限，只需包含其中一个
	hasPermiOr(permissions) {
		return permissions.some(item => {
			return authPermission(item);
		});
	},
	// 验证用户是否含有指定权限，必须全部拥有
	hasPermiAnd(permissions) {
		return permissions.every(item => {
			return authPermission(item);
		});
	},
	// 验证用户是否具备某角色
	hasRole(role) {
		return authRole(role);
	},
	// 验证用户是否含有指定角色，只需包含其中一个
	hasRoleOr(roles) {
		return roles.some(item => {
			return authRole(item);
		});
	},
	// 验证用户是否含有指定角色，必须全部拥有
	hasRoleAnd(roles) {
		return roles.every(item => {
			return authRole(item);
		});
	},
};
